import { FC, useId } from 'react';

import { DropdownButtonContactType } from '@/entities/contact/components/DropdownButtonContactType';
import { ContactType } from '@/shared/lib/sj-orm';
import { CollectionName } from '@/shared/lib/sj-orm/types';
import { Button } from '@/shared/uikitV2/Button';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';

import { BtnClose } from '../../components/BtnClose';
import { SelectItem } from '../../components/SelectItem';
import { SelectOptions } from '../../components/SelectItem/types';
import { useModalsStore } from '../../modals.store';
import { SelectContactProps } from '../../types';

import { Actions, Body, Container, Header, MainActions, StyledDrawer, Title } from './styled';

export const SelectContactModal: FC<SelectContactProps> = ({
  onSelect,
  onClose,
  contactTypes,
  filter,
  selectedValue,
}) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'selectContact' });
  const modals = useModalsStore();

  const formId = useId();

  const handleClose = () => {
    onClose?.();
    modals.closeModal();
  };
  const handleSubmit = (data: SelectOptions) => {
    modals.closeModal();
    onSelect(Array.isArray(data.id) ? String(data.id[0]) : data.id.toString());
  };

  const handleAddNew = (contactType: ContactType) => {
    modals.openModal({ type: 'FastCreateContact', contactType });
  };

  return (
    <StyledDrawer width={800} footer={null} closable={false} onClose={handleClose} open>
      <Container>
        <Header>
          <BtnClose onClick={handleClose} style={{ position: 'absolute', right: 24, top: 24 }} />
          <Title style={{ maxWidth: '80%' }} className="truncate" size={22} bold>
            {t('title')}
          </Title>
        </Header>
        <Body style={{ marginRight: 4 }} className="uikitScrollbar">
          <SelectItem
            values={[selectedValue]}
            formId={formId}
            colName={CollectionName.CONTACTS}
            onSelect={handleSubmit}
            filter={filter}
          />
        </Body>
        <Actions>
          <Button type="text" onClick={handleClose}>
            {t('btnCancel')}
          </Button>
          <MainActions>
            <DropdownButtonContactType
              onSelect={handleAddNew}
              text={t('btnAddNew')}
              filter={(type) => contactTypes.includes(type)}
            />
            <Button style={{ width: 90 }} htmlType="submit" form={formId}>
              {t('btnConfirm')}
            </Button>
          </MainActions>
        </Actions>
      </Container>
    </StyledDrawer>
  );
};
